/**
 * 報告不要業者事業場
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/non_reporting_traders`

const non_reporting_trader_location = {
  namespaced: true,
  state: {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      // name: null,
      // number: null,
    },
  },
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     *
     * @param commit
     * @param trader_id
     * @return {Promise<unknown>}
     */
    index ({ commit }, { trader_id, page}) {
      const api_path = `${API_PATH}/${trader_id}/locations`
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: { page: page } }).then(data => {
            resolve(data.content)
        })
      })
    },
    new ({ commit }, { trader_id }) {
      const api_path = `${API_PATH}/${trader_id}/locations/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /* 報告不要業者詳細フォームの事業場 **/
    edit ({ commit }, { trader_id, id }) {
      const api_path = `${API_PATH}/${trader_id}/locations/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { trader_id, params }) {
      const api_path = `${API_PATH}/${trader_id}/locations`
      return new Promise( ( resolve ) => {
        Vue.$http.post(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    update ({ commit },{ trader_id, id, params }) {
      const api_path = `${API_PATH}/${trader_id}/locations/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.patch(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { trader_id, id }) {
      const api_path = `${API_PATH}/${trader_id}/locations/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default non_reporting_trader_location
